(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9236],{

/***/ 20226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services-centers",
      function () {
        return __webpack_require__(16541);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ services_centers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./components/mapPages/map/MapContext.tsx + 1 modules
var MapContext = __webpack_require__(95887);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./hooks/useGeolocation.ts
var useGeolocation = __webpack_require__(17942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/wrappers/InnerPageWrapper.tsx
var InnerPageWrapper = __webpack_require__(45732);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./reusable/popups/ErrorLocationPopUp.tsx
var ErrorLocationPopUp = __webpack_require__(28114);
// EXTERNAL MODULE: ./reusable/TwoToggleButtons.tsx
var TwoToggleButtons = __webpack_require__(70498);
// EXTERNAL MODULE: ./components/mapPages/AreSelectionButtons.tsx
var AreSelectionButtons = __webpack_require__(62573);
// EXTERNAL MODULE: ./components/mapPages/map/DynamicMap.tsx + 1 modules
var DynamicMap = __webpack_require__(66166);
// EXTERNAL MODULE: ./components/mapPages/map/utils/mapFilters.ts
var mapFilters = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 8 modules
var Autocomplete = __webpack_require__(80361);
;// CONCATENATED MODULE: ./components/mapPages/serviceCenters/CitySearch.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiAutocomplete-popupIndicatorOpen {\n    transform: rotate(0deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledAutocomplete = (0,styled_components_browser_esm/* default */.ZP)(Autocomplete/* default */.ZP).withConfig({
    displayName: "CitySearch__StyledAutocomplete",
    componentId: "sc-3663f46-0"
})(_templateObject());
var CitySearch = function(param) {
    var cities = param.cities, setSelectedCity = param.setSelectedCity, className = param.className;
    var setSelectedStore = (0,MapContext/* useMapContext */.fx)().setSelectedStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAutocomplete, {
            id: "cityAutocomplete",
            popupIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                color: "primary"
            }),
            // forcePopupIcon={true}
            options: cities,
            color: "primary",
            renderInput: function(params) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    label: "חפש עיר",
                    variant: "outlined"
                }));
            },
            autoHighlight: true,
            onChange: function(_, value) {
                setSelectedCity(value);
                setSelectedStore(null);
            }
        })
    });
};
/* harmony default export */ var serviceCenters_CitySearch = (/*#__PURE__*/(0,react.memo)(CitySearch));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./components/mapPages/CardRowText.tsx
var CardRowText = __webpack_require__(94316);
;// CONCATENATED MODULE: ./components/mapPages/serviceCenters/ServiceCentersItem.tsx

function ServiceCentersItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background-color: ",
        ";\n  padding: 20px 15px;\n  border-radius: 6px;\n  border: 1.5px solid\n    ",
        ";\n"
    ]);
    ServiceCentersItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    flex-grow: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServiceCentersItem__StyledWrapper",
    componentId: "sc-16e32ed6-0"
})(ServiceCentersItem_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$selected ? p.theme.colors.saphire : p.theme.colors.transparent;
});
var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "ServiceCentersItem__StyledHeadline",
    componentId: "sc-16e32ed6-1"
})(_templateObject1());
var StyledButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServiceCentersItem__StyledButtonWrap",
    componentId: "sc-16e32ed6-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ServiceCentersItem__StyledButton",
    componentId: "sc-16e32ed6-3"
})(_templateObject3());
var ServiceCentersItem = function(param) {
    var serviceCenter = param.serviceCenter, isServiceCenterSelected = param.isServiceCenterSelected;
    var serviceCenterRef = (0,react.useRef)(null);
    // Scroll to Service Center Card in right sidebar
    // when User clicks on a map marker
    (0,react.useEffect)(function() {
        if (isServiceCenterSelected && serviceCenter) {
            serviceCenterRef.current.scrollIntoView(false);
        }
    });
    var link = "/service-center/[serviceCenterId]/[serviceCenterSlug]".replace("[serviceCenterId]", serviceCenter.id.toString()).replace("[serviceCenterSlug]", (0,slugify/* default */.Z)(serviceCenter.name));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        ref: serviceCenterRef,
        $selected: isServiceCenterSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: link,
                    children: serviceCenter === null || serviceCenter === void 0 ? void 0 : serviceCenter.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                data: serviceCenter === null || serviceCenter === void 0 ? void 0 : serviceCenter.address,
                iconName: "mazdaLocationIcon",
                imageAlt: "location-מיקום"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                data: serviceCenter.whatsapp,
                link: serviceCenter.whatsappLink,
                iconName: "whatsappLogo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                data: serviceCenter.phone,
                link: "tel:".concat(serviceCenter.phone),
                iconName: "phoneCall",
                imageAlt: "phone-טלפון"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                    data: serviceCenter === null || serviceCenter === void 0 ? void 0 : serviceCenter.fax,
                    iconName: "fax",
                    imageAlt: "fax-פקס"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                $gap: "10px",
                $fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                        children: serviceCenter.wazeLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: serviceCenter.wazeLink,
                                passHref: true,
                                openInNewTab: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: "ניווט ב-Waze"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            passHref: true,
                            href: link,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                variant: "outlined",
                                fullWidth: true,
                                children: "לתיאום הגעה"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var serviceCenters_ServiceCentersItem = (/*#__PURE__*/(0,react.memo)(ServiceCentersItem));

;// CONCATENATED MODULE: ./components/mapPages/serviceCenters/ServiceCentersList.tsx

function ServiceCentersList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  direction: rtl;\n  text-align: right;\n  height: 100%;\n  ",
        " {\n    padding-right: 10px;\n  }\n"
    ]);
    ServiceCentersList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ServiceCentersList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ServiceCentersList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "ServiceCentersList__StyledList",
    componentId: "sc-5c411986-0"
})(ServiceCentersList_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ServiceCentersList__StyledListItem",
    componentId: "sc-5c411986-1"
})(ServiceCentersList_templateObject1());
var ServiceCentersList = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,MapContext/* useMapContext */.fx)(), selectedStore = ref.selectedStore, onStoreClick = ref.onStoreClick, filterStores = ref.filterStores;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
        children: !!(filterStores === null || filterStores === void 0 ? void 0 : filterStores.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filterStores.map(function(item, i) {
                return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                    tabIndex: 0,
                    onClick: function() {
                        onStoreClick(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(serviceCenters_ServiceCentersItem, {
                        serviceCenter: item,
                        isServiceCenterSelected: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id) === (item === null || item === void 0 ? void 0 : item.id)
                    })
                }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(serviceCenters_ServiceCentersItem, {
                        serviceCenter: item,
                        isServiceCenterSelected: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id) === (item === null || item === void 0 ? void 0 : item.id)
                    })
                }, i);
            })
        })
    });
};
/* harmony default export */ var serviceCenters_ServiceCentersList = (/*#__PURE__*/(0,react.memo)(ServiceCentersList));

;// CONCATENATED MODULE: ./components/mapPages/serviceCenters/ServiceCentersPage.tsx



function ServiceCentersPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: 40px;\n  width: 100%;\n"
    ]);
    ServiceCentersPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ServiceCentersPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  direction: ltr;\n  ::-webkit-scrollbar-track {\n    background: #d5d5d5;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: #999999;\n    height: 80px;\n  }\n  ",
        " {\n    width: 350px;\n    flex-shrink: 0;\n    height: 680px;\n    overflow-y: auto;\n  }\n"
    ]);
    ServiceCentersPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ServiceCentersPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  flex-shrink: 0;\n  height: 680px;\n  position: sticky;\n  transition: top 221ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  align-self: flex-start;\n  padding: 0px 25px;\n"
    ]);
    ServiceCentersPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ServiceCentersPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 320px;\n    margin: 0 auto;\n  }\n"
    ]);
    ServiceCentersPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  ",
        " {\n    max-width: 320px;\n    margin: 40px auto 0px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}















var StyledContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServiceCentersPage__StyledContentWrap",
    componentId: "sc-f8362ee3-0"
})(ServiceCentersPage_templateObject());
var StyledContentSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ServiceCentersPage__StyledContentSection",
    componentId: "sc-f8362ee3-1"
})(ServiceCentersPage_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledMapSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ServiceCentersPage__StyledMapSection",
    componentId: "sc-f8362ee3-2"
})(ServiceCentersPage_templateObject2());
var StyledTwoToggleButtons = (0,styled_components_browser_esm/* default */.ZP)(TwoToggleButtons/* default */.Z).withConfig({
    displayName: "ServiceCentersPage__StyledTwoToggleButtons",
    componentId: "sc-f8362ee3-3"
})(ServiceCentersPage_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledLocationWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ServiceCentersPage__StyledLocationWrap",
    componentId: "sc-f8362ee3-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledCitySearch = (0,styled_components_browser_esm/* default */.ZP)(serviceCenters_CitySearch).withConfig({
    displayName: "ServiceCentersPage__StyledCitySearch",
    componentId: "sc-f8362ee3-5"
})(_templateObject5());
var ServiceCentersPage = function() {
    var ref = (0,MapContext/* useMapContext */.fx)(), setStores = ref.setStores, setMap = ref.setMap, setMaps = ref.setMaps, stores = ref.stores, setFilterStores = ref.setFilterStores, setSelectedStore = ref.setSelectedStore, alphabetOrderStores = ref.alphabetOrderStores, setAlphabetOrderStores = ref.setAlphabetOrderStores;
    // toggle states:
    var ref1 = (0,react.useState)(mapFilters/* ToggleButtons.CLOSE_TO_ME */.s0.CLOSE_TO_ME), toggleIndex = ref1[0], setToggleIndex = ref1[1];
    var ref2 = (0,react.useState)(mapFilters/* Areas.ALL */.Bg.ALL), selectedAreaId = ref2[0], setSelectedAreaId = ref2[1];
    // additional filter for cities
    var cities = (stores === null || stores === void 0 ? void 0 : stores.map(function(item) {
        return item.city;
    }).filter(function(value, i, array) {
        return array.indexOf(value) === i;
    }).sort(function(a, b) {
        return a.localeCompare(b);
    })) || [];
    var ref3 = (0,react.useState)(""), selectedCity = ref3[0], setSelectedCity = ref3[1];
    var ref4 = (0,react.useState)(false), inHesder = ref4[0];
    // popup States:
    var ref5 = (0,react.useState)(false), userHasSeenPopUpError = ref5[0], setUserHasSeenPopUpError = ref5[1];
    var ref6 = (0,react.useState)(false), openErrorPopUp = ref6[0], setOpenErrorPopUp = ref6[1];
    // location states:
    var ref7 = (0,useGeolocation/* default */.Z)(), loaded = ref7.loaded, error = ref7.error, lng = ref7.lng, lat = ref7.lat;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    // if user allow location and we have coordinates (lat,lng) call the api
    (0,react.useEffect)(function() {
        if (error.code !== "") {
            setToggleIndex(mapFilters/* ToggleButtons.AREAS */.s0.AREAS);
        }
        var isComponentMounted = true;
        if (error.code != "" && !userHasSeenPopUpError) {
            setOpenErrorPopUp(true);
        }
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, alphabetData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isComponentMounted) return [
                                3,
                                3
                            ];
                            if (!(loaded && lng && lat)) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                (0,api/* getServiceCenter */.Bz)(lng, lat).then(api/* extractData */.Kj)
                            ];
                        case 1:
                            data = _state.sent();
                            return [
                                4,
                                (0,api/* getServiceCenter */.Bz)(null, null).then(api/* extractData */.Kj)
                            ];
                        case 2:
                            alphabetData = _state.sent();
                            setAlphabetOrderStores(alphabetData === null || alphabetData === void 0 ? void 0 : alphabetData.body);
                            setStores(data === null || data === void 0 ? void 0 : data.body);
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData().catch(console.error);
        return function() {
            isComponentMounted = false;
        };
    }, [
        error,
        loaded,
        lng,
        lat
    ]);
    // filter the stores:
    (0,react.useEffect)(function() {
        //Filter options updated so apply all filters here
        var result = toggleIndex === mapFilters/* ToggleButtons.CLOSE_TO_ME */.s0.CLOSE_TO_ME ? stores : alphabetOrderStores;
        result = (0,mapFilters/* locationFilterListService */.Le)(result, selectedAreaId, toggleIndex);
        result = (0,mapFilters/* cityFilterList */.Z3)(result, selectedCity);
        result = (0,mapFilters/* isInHesderFilterList */.kB)(result, inHesder);
        setFilterStores(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stores,
        selectedAreaId,
        toggleIndex,
        selectedCity,
        inHesder
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerPageWrapper/* default */.Z, {
            title: "מרכזי השירות של מאזדה",
            subtitle: "מרכזי השירות שלנו פרוסים בכל הארץ, זמינים לטפל בכל עניין וללוות אותך לשנים. לחיפוש מרכז שירות ולתיאום הגעה, יש לבחור באחת מהאפשרויות",
            imgUrl: isDesktop ? "/img/cover/Servicecenters.jpg" : "/img/cover/Servicecentersmobile.jpg",
            breadCrumbName: "ServicesCenters",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoToggleButtons, {
                    activeButton: toggleIndex,
                    setActiveButton: setToggleIndex,
                    optionsList: [
                        "קרוב אליי",
                        "לפי אזור"
                    ],
                    toggleId: "map-toggle"
                }),
                toggleIndex === mapFilters/* ToggleButtons.AREAS */.s0.AREAS && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocationWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AreSelectionButtons/* default */.Z, {
                            activeButton: selectedAreaId,
                            setActiveButton: setSelectedAreaId,
                            onSelectFunction: function() {
                                return setSelectedStore(null);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCitySearch, {
                            cities: cities,
                            setSelectedCity: setSelectedCity
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContentSection, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(serviceCenters_ServiceCentersList, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMapSection, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMap/* default */.Z, {
                                    setMaps: setMaps,
                                    setMap: setMap
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLocationPopUp/* default */.Z, {
                    open: openErrorPopUp,
                    setOpen: setOpenErrorPopUp,
                    setUserHasSeenPopUpError: setUserHasSeenPopUpError
                })
            ]
        })
    });
};
/* harmony default export */ var serviceCenters_ServiceCentersPage = (ServiceCentersPage);

;// CONCATENATED MODULE: ./src/pages/services-centers.tsx




var ServicesCenters = function(param) {
    var pageData = param.pageData, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MapContext/* MapContextProvider */.sf, {
                itemList: pageData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(serviceCenters_ServiceCentersPage, {})
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var services_centers = (ServicesCenters);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,5229,1090,161,9774,2888,179], function() { return __webpack_exec__(20226); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);